import {connect} from "react-redux";
import type {ApplicationState} from "../../../reducers";
import PayPalExpressButton from "../../../components/checkout/dataSummaryBox/PayPalExpressButton";
import {
    notifyPayPalPaymentCancelled,
    notifyPayPalPaymentSuccessful,
    onPayPalExpressOrderCreated,
    onPayPalExpressPaymentAssigned,
    setPaymentError
} from "../../../actions/order";
import type {PaymentFacilitySessionResponse} from "../../../api/PaymentApi";
import type {Order} from "../../../models/Order";
import {PAYMENT_METHODS} from "../../../models/PaymentRequests";
import {CHECKOUT_PAGE_STATUS} from "../../../components/checkout/CheckoutPage";
import {checkoutPageStepSet} from "../../../reducers/orderReducer";

const mapStateToProps = (state: ApplicationState, _ownProps) => {
	return {
	};
};

const mapDispatchToProps = dispatch => {
	return {
        onOrderCreated: (order: Order) => {
            dispatch(onPayPalExpressOrderCreated(order));
        },
        onPaymentAssigned: (response: PaymentFacilitySessionResponse) => {
            dispatch(onPayPalExpressPaymentAssigned(response));
        },
		onPaymentSuccess: (_referenceId: string) => {
			dispatch(notifyPayPalPaymentSuccessful());
            dispatch(checkoutPageStepSet(CHECKOUT_PAGE_STATUS.OVERVIEW));
		},
        onPaymentCancelled: () => {
            dispatch(notifyPayPalPaymentCancelled())
        },
		onPaymentFailure: () => {
			dispatch(setPaymentError(PAYMENT_METHODS.PAYPAL_EXPRESS));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PayPalExpressButton);
